
































































import Vue from "vue";
// types
import { DataTableHeader } from "vuetify/types";
import { AdunitGroup } from "@/features/adunitGroup/types";

export default Vue.extend({
  name: "AdunitGroupTable",
  props: {
    adunitGroupList: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      formSearchValue: "" as string,
      searchValue: "" as string,
      index: 1 as number,
    };
  },
  computed: {
    tableHeader(): DataTableHeader[] {
      return [
        {
          text: String(this.$t("adUnitGroup.tableHeader.name")),
          value: "adunitGroupName",
          width: "45%",
        },
        {
          text: String(this.$t("adUnitGroup.tableHeader.publisher")),
          value: "publisherName",
          width: "45%",
        },
        {
          text: "",
          value: "action",
          width: "1%",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    onClickTableRow(adunitGroup: AdunitGroup) {
      this.$router.push({
        name: "AdunitGroupEdit",
        params: { adunitGroupId: String(adunitGroup.adunitGroupId) },
      });
    },
    onClickDeleteMenu(adunitGroup: AdunitGroup) {
      this.$emit("showDeleteDialog", adunitGroup);
    },
    adunitGroupsFilter(
      value: string | undefined | null,
      search: string | null,
      item: AdunitGroup
    ): boolean {
      return value != null && search != null && item.adunitGroupName.includes(search);
    },
    execSearch() {
      this.index = 1;
      this.searchValue = this.formSearchValue;
    },
    clearSearch() {
      this.index = 1;
      this.searchValue = "";
    },
  },
});
